import { useTranslate } from '../i18n/index.tsx';
import { Centered } from './Centered.tsx';

export const NotFoundPage = () => <Centered>{useTranslate()('errors.notFound')}</Centered>;
